export default __webpack_public_path__ + "static/media/planet-1-large.daca7b5b.png";